import { TableHeaderConfig } from 'types/table/TableHeaderConfig.type';
import style from './report-overview.module.scss';
import clsx from 'clsx';

interface ReportColumns {
  clientName: string;
  clientSurname: string;
  investmentType: string;
}

export const reportOverviewHeaderData: TableHeaderConfig<ReportColumns>[] = [
  {
    label: '',
    className: clsx(style.headers, style.smallHeader)
  },
  {
    key: 'clientName',
    label: 'Client First Name',
    className: style.headers
  },
  {
    key: 'clientSurname',
    label: 'Client Surname',
    className: style.headers
  },
  {
    key: 'investmentType',
    label: 'Investment Type',
    className: style.headers
  }
];
